// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/pin.js';

import { paths } from '../generated/pin';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('pin', Original, paths);
